<template>
  <div class="investor">
    <p class="text">If you have an opportunity that you would like to be considered for hosting on this platform, please email a summary of the opportunity and all relevant details to</p>
    <p class="link"><a href="mailto:prosperafrica@usaid.gov" @click="contactUs">prosperafrica@usaid.gov</a></p>
  </div>
</template>

<script>
export default {
  name: 'investor-banner',
  methods: {
    contactUs () {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-contact-us',
        eventLabel: 'Contact us investor banner'
      })
    }
  }
}
</script>

<style  lang="scss">
@import "@/assets/styles/variables.scss";
.investor {
  background: rgb(255,251,243);
  padding: 40px;
  .text {
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    color: #002f6c;
  }
  .link a {
    color: #002f6c;
    font-size: 16px;
    font-weight: 500;
    font-family: $header-font;
    text-decoration: none;
    @media (min-width: 768px) {
      font-size: 22px;
    }
  }
}
</style>
